import ApiService from '../common/api.service'

class SubscriptionService extends ApiService {

  /**
   * Get subscriptions.
   * @param {object} parameters (vin, page and nbItemPerPage)
   * @return {Promise} Promise of the subscriptions
   */
  getSubscriptions (params) {
    return this.get(`/vehicles/${params.vin}/subscriptions`, {
      params: {
        page: params.page,
        nbItemPerPage: params.nbItemPerPage
      }
    }).then((res) => {
      this.$log.info('Fetched subscriptions', res.data)
      return Promise.resolve(res.data)
    })
  }

  /**
   * Get transferable subscriptions.
   * @param {String} source Source VIN
   * @param {String} target Target VIN
   * @return {Promise} Promise of the subscriptions
   */
  getTransferableSubscriptions (source, target) {
    return this.get(`/vehicles/${source}/subscriptions/transfer`, {params: {vin: target}})
      .then((res) => {
        this.$log.info('Fetched transferable subscriptions', res.data)
        return Promise.resolve(res.data)
      })
  }

  /**
   * Transfer subscriptions from a vin to another.
   * @param {String} source Source VIN
   * @param {String} target Target VIN
   * @return {Promise} Promise of the transfer
   */
  transferSubscriptions (source, target) {
    return this.put(`/vehicles/${source}/subscriptions/transfer`, null, {params: {vin: target}})
      .then((res) => {
        this.$log.info('Subscriptions transfert requested', res.data)
        return Promise.resolve(res.data)
      })
  }
}

export default SubscriptionService



// WEBPACK FOOTER //
// ./src/app/services/subscription/subscription.service.js